/**
 * contact
 */
'use strict';
import AppContact from '@/_modules/app_contact';

document.addEventListener('DOMContentLoaded', () => {
  new AppContact();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
